import { Component, Input, OnInit } from '@angular/core';
import { AgGridI } from '../../ag-grid/ag-grid.model';
import { ImportDocumentsService } from '../../../../components/import-documents/import-documents.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AgCustomHeaderComponent } from '../../../../shared/components/ag-grid/ag-custom-header/ag-custom-header.component';
import { AgGridImportCommonMap } from '../../../../components/import-documents/pages/map-tab/map-tab.model';
import { CommonService } from '../../../../shared/services/common.service';
import { TabsService } from '../../tabs/tabs.service';
import { ImportMappingService } from '../../../import/import-mapping.service';
import { applyAutoMapToRows, filterMappableSystemColumns, filterUnmappedUploadedColumns, isImportModelProvidedField } from '../../../import/import-field-definitions';
import { Button, ImportTemplateSource, RoutePath } from '../../../model/enum';
import { SendDataService } from '../../../services/send-data.service';
import { ModalPopupSize } from '../../../model/common.model';
import { CommonTemplateTabComponent } from '../common-template-tab/common-template-tab.component';
import { InsertUpdateImportDocumnets } from '../../../../components/import-documents/import-documents.model';
import { ProgressHelperService } from '../../../../components/import-documents/pages/step-progressbar/progress-helper.service';
import { CommonImportDocumentService } from '../../../../components/common-import-document/common-import-document.service';

@Component({
  selector: 'app-common-map-tab',
  templateUrl: './common-map-tab.component.html',
  styleUrls: ['./common-map-tab.component.scss']
})
export class CommonMapTabComponent implements OnInit {
  dataModel: AgGridI;
   gridApi;
   gridColumnApi;
   insertUpdateImportDocumnets = new InsertUpdateImportDocumnets();
  public components: {
    [p: string]: any;
  } = {
      agColumnHeader: AgCustomHeaderComponent,
    }
  isLoading: boolean = false;
  overlayNoRowsTemplate = '<div class="ag-overlay-no-rows-center">No Records Available</div>';
  enumButtonName = Button;

@Input() data:any = {}
flexHeight;
columnList: [];
routePath = RoutePath;
mapList:any = [];

  constructor(
    public importDocumentsService: ImportDocumentsService,
    private importMappingService: ImportMappingService,
    private router: Router,
    public toaster: ToastrService,
    public  commonImportService: CommonImportDocumentService,
    public commonService: CommonService,
    public tabsService: TabsService,
    private progressHelper: ProgressHelperService,
    private sendDataService: SendDataService,
) {  }

  ngOnInit(): void {
      this.dataModel = AgGridImportCommonMap;
      this.getMapList()
      this.commonService.headerHeight.subscribe(res => {
        this.flexHeight = "calc(100vh - 415px - " + res + "px" + ")"
      })
      this.tabsService.onSubNavChanged.subscribe((url=>{
        if(url!== undefined)
          this.getMapList()
      }));
      this.commonService.getMapData.subscribe((data=>{
        if(data && this.data?.activeTab == 1)
          this.getMapToList()
      }));
  }
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.data.mapData.gridApi = params;
    // Listen to grid changes to recalculate unmapped headers and update validation
    this.gridApi.addEventListener('cellValueChanged', () => {
      this.recalculateUnmappedColumns();
      this.updateRequiredFieldValidation();
    });
  }
  getMapList() {
    let id = this.data?.importData?.mappingTemplateId??''
    let hasMappedColumn = this.data?.mapData?.rowData?.some(x => !!x.mappedColumn && x.templateId === id ) ?? false;
    if(hasMappedColumn)return
    let maplist = this.mapList
    this.isLoading = true;
    this.data.mapData.rowData = filterMappableSystemColumns(
      this.data?.mapData?.staticSystemColumns ?? [],
      this.data?.sourceId ?? ImportTemplateSource.Parts
    ).map(systemColumn => ({ systemColumn }));
    this.data?.mapData?.rowData?.map((a) => {
      a.map = maplist
      a.requiredField = this.data?.mapData?.requiredField;
      a.templateId = a?.templateId ?? '';
      a.id = a?.id ?? '';
      a.status = false;
      a.mappedColumn = '';
      // Set isRequired based on requiredField array
      if (this.data?.mapData?.requiredField?.includes(a.systemColumn)) {
        a.isRequired = true;
      } else {
        a.isRequired = false;
      }
    })
    if(this.data?.mapData?.rowData?.length > 0) {
      this.isLoading = false;
      this.runAutoMap();
    }

  }
  getMapToList() {
    let id = this.data?.importData?.mappingTemplateId??''
    let hasMappedColumn = this.data?.mapData?.rowData?.some(x => !!x.mappedColumn && x.templateId === id ) ?? false;
    if(hasMappedColumn)return
    if(!this.data?.importData?.file)return
    const data = { file: this.data?.importData?.file}
    this.importDocumentsService.mapToList(data).subscribe(res => {
      this.mapList = res?.response ?? [];
      if (this.data?.importData?.mappingTemplateId
        && this.data.importData.mappingTemplateId !== '0'
      ) {
        this.getMapListById(this.data?.importData?.mappingTemplateId,this.data?.sourceId?? 1)
      } else {
        this.getMapList();
      }
    })
    }
  getMapListById(mappingId,soueceId){
    this.isLoading = true;
    this.importDocumentsService.getImportCompanyTemplateById(mappingId,soueceId).subscribe(res=>{
      if(res?.response){
      this.data.mapData.rowData = (res?.response?.templateMappingColumns ?? [])
        .filter((row) => !isImportModelProvidedField(soueceId, row.systemColumn));
      this.data?.mapData?.rowData?.map((a)=>{
        a.map=this.mapList
      });
      this.data?.mapData?.rowData?.map((a) => {
          if (this.data?.mapData?.requiredField?.includes(a.systemColumn)) {
            a.isRequired = true;
          } else {
            a.isRequired = false;
          }
        })
      this.data.templateData = {
        ...this.data.templateData,
       ...res?.response
      };
      if(this.data.mapData.rowData?.length > 0) {
        this.isLoading = false;
        this.runAutoMap();
      }
    }
    })
  }

  private runAutoMap() {
    const file = this.data?.importData?.file;
    const sourceId = this.data?.sourceId ?? ImportTemplateSource.Parts;
    if (!file || !this.data?.mapData?.rowData?.length) return;

    this.importMappingService.autoMapFields(file, sourceId).subscribe((res:any) => {
      if (!res?.isSuccess || !res?.response) return;
      const headerOptions = this.mapList?.length ? this.mapList : (res.response.uploadedHeaders ?? []);
      this.data.mapData.uploadedHeaders = res.response.uploadedHeaders ?? headerOptions;
      const applied = applyAutoMapToRows(
        this.data.mapData.rowData,
        res.response,
        headerOptions,
        sourceId
      );
      this.data.mapData.rowData = applied.rowData;
      this.data.mapData.unmappedUploadedColumns = applied.unmappedColumns;
      if (!this.mapList || !this.mapList.length) {
        this.mapList = headerOptions;
      }
      this.data.mapData.requiredMissingCount = res.response.requiredMissingCount;
      this.data.mapData.canProceed = applied.canProceed;
      this.data.mapData.blockImport = res.response.blockImport ?? applied.blockImport;
      this.importDocumentsService.submit = !this.data.mapData.blockImport;
      this.data.mapData.gridApi?.setRowData?.(this.data.mapData.rowData);
      // Recalculate unmapped headers and validation after auto mapping
      this.recalculateUnmappedColumns();
      this.updateRequiredFieldValidation();
    });
  }

  recalculateUnmappedColumns(): void {
    if (!this.mapList?.length) {
      const firstRow = this.data?.mapData?.rowData?.[0];
      if (firstRow?.map) {
        this.mapList = firstRow.map;
      }
    }
    const headers = this.data?.mapData?.uploadedHeaders?.length
      ? this.data.mapData.uploadedHeaders
      : this.mapList;
    if (!headers?.length) return;

    const mappedColumns: string[] = [];
    this.gridApi?.forEachNode((node) => {
      if (node.data) {
        const mappedCol = node.data.mappedColumn?.trim();
        if (!!mappedCol && mappedCol !== '-Select Field-') {
          mappedColumns.push(mappedCol);
        }
      }
    });

    this.data.mapData.unmappedUploadedColumns = filterUnmappedUploadedColumns(
      headers,
      this.data?.sourceId ?? ImportTemplateSource.Parts,
      mappedColumns
    );
  }

  private updateRequiredFieldValidation(): void {
    // Check if all required fields are mapped
    const requiredNotMapped = this.data?.mapData?.rowData?.filter((row: any) => 
      row.isRequired && !row.mappedColumn
    )?.length ?? 0;
    
    this.data.mapData.canProceed = requiredNotMapped === 0;
    this.data.mapData.blockImport = !this.data.mapData.canProceed;
  }

  openTemplateSettingModal() {
    this.data.templateData = {
      ...this.data.templateData,
      fileName: this.data.importData?.fileName,
      mappingTemplateId: this.data?.importData?.mappingTemplateId ?? '0'
    };

    // Clone templateData so the modal works on a copy
    const modalData = { ...this.data };

    this.sendDataService.openModalPopup(
      CommonTemplateTabComponent,
      modalData,
      'Template Settings',
      ModalPopupSize.LG,
      'markAsAddEditAddress has-parent-popup'
    ).then((resultData) => {
      if (resultData?.confirm && resultData?.templateData) {
        this.data.templateData = {
          ...this.data.templateData,
          ...resultData.templateData
        };

        this.insertUpdateImportDocumnets.templateData.templateName = resultData.templateData.templateName;
        this.insertUpdateImportDocumnets.templateData.templateDescription = resultData.templateData.templateDescription;
        this.insertUpdateImportDocumnets.templateData.isTemplateCreate = resultData.templateData.isTemplateCreate;
        this.insertUpdateImportDocumnets.importModel.mappingTemplateId = resultData.templateData.mappingTemplateId;

        if (!this.validateRequiredFields()) {
          this.toaster.error('Please map all required fields before saving template');
          return;
        }

        if (!this.prepareMappingData()) return;
        this.callImportApi(false);
      }
    });
  }

  private validateRequiredFields(): boolean {
    // Check if all required fields are mapped
    const requiredNotMapped = this.data?.mapData?.rowData?.filter((row: any) => 
      row.isRequired && !row.mappedColumn
    )?.length ?? 0;
    
    return requiredNotMapped === 0;
  }

  prepareMappingData(): boolean {
    const list: any = [];
    if (this.gridApi) {
      this.gridApi.forEachNode((a) => {
        if (a.data) {
          list.push(a.data);
        }
      });
    } else {
      list.push(...(this.data?.mapData?.rowData ?? []));
    }

    list.map((b) => {
      if (b.mappedColumn === b.systemColumn) {
        b.status = true;
      }
    });

    list.map((a) => {
      if (this.data?.mapData?.requiredField?.includes(a.systemColumn)) {
        a.isRequired = true;
      } else {
        a.isRequired = false;
      }
    });

    const importData = this.data?.importData ?? {};
    this.insertUpdateImportDocumnets.importModel.file = importData.file ?? '';
    this.insertUpdateImportDocumnets.importModel.companyId = 
      importData.companyId ?? 
      importData.vendorId ?? 
      importData.customerId ?? 
      importData.consignorId ?? 
      '';
    this.insertUpdateImportDocumnets.importModel.contactId = importData.contactId ?? '';

    this.insertUpdateImportDocumnets.templateData.templateMappingColumns = list;
    return true;
  }

  public callImportApi(advancestep: boolean): void {
    if(this.router.url == this.routePath.PARTLIST_IMPORT_INVENTORY_ROUTEPATH){
      this.inventoryImport(advancestep);
    }else if(this.router.url == this.routePath.PARTLIST_IMPORT_PARTS_ROUTEPATH){
      this.importParts(advancestep);
    }else if(this.router.url == this.routePath.PARTLIST_IMPORT_OEMEXCESS_ROUTEPATH){
      this.importOemExcess(advancestep);
    }else if(this.router.url == this.routePath.PARTLIST_IMPORT_VENDORPARTS_ROUTEPATH){
     this.importVendorParts(advancestep);
    }else if(this.router.url == this.routePath.PARTLIST_IMPORT_CONSIGNMENT_ROUTEPATH){
     this.importConsignment(advancestep);
    }
  }
  
  inventoryImport(advancestep: boolean) {
    this.insertUpdateImportDocumnets.templateData.sourceId = 5;
    this.insertUpdateImportDocumnets.isVendor = true;
    const payload = { ...this.insertUpdateImportDocumnets };
    this.commonImportService.importInventoryTemplate(payload).subscribe({
      next: (res) => {
        if (res.isSuccess) {
          const templateId = res?.response?.templateId ?? res?.response?.moduleData?.templateId ?? '0';
          this.insertUpdateImportDocumnets.importModel.mappingTemplateId = templateId;
          this.importDocumentsService.dataPassAccordingToTrackingBar.next(res);
          if (advancestep) {
            this.progressHelper.eventHelper.next({ prev: false, next: true });
          } else {
            this.toaster.success('Template saved successfully!');
          }
        }
      },
      error: (err) => {
        this.toaster.error('Failed to save template.');
      }
    });
  }

  importParts(advancestep: boolean) {
    this.insertUpdateImportDocumnets.templateData.sourceId = 4;
    this.insertUpdateImportDocumnets.isVendor = true;
    const payload = { ...this.insertUpdateImportDocumnets };
    this.commonImportService.importPartTemplate(payload).subscribe({
      next: (res) => {
        if (res.isSuccess) {
          const templateId = res?.response?.templateId ?? res?.response?.moduleData?.templateId ?? '0';
          this.insertUpdateImportDocumnets.importModel.mappingTemplateId = templateId;
          this.importDocumentsService.dataPassAccordingToTrackingBar.next(res);
          if (advancestep) {
            this.progressHelper.eventHelper.next({ prev: false, next: true });
          } else {
            this.toaster.success('Template saved successfully!');
          }
        }
      },
      error: (err) => {
        this.toaster.error('Failed to save template.');
      }
    });
  }

  importOemExcess(advancestep: boolean) {
    this.insertUpdateImportDocumnets.templateData.sourceId = 8;
    this.insertUpdateImportDocumnets.isVendor = true;
    const payload = { ...this.insertUpdateImportDocumnets };
    this.commonImportService.importOemExcessTemplate(payload).subscribe({
      next: (res) => {
        if (res.isSuccess) {
          const templateId = res?.response?.templateId ?? res?.response?.moduleData?.templateId ?? '0';
          this.insertUpdateImportDocumnets.importModel.mappingTemplateId = templateId;
          this.importDocumentsService.dataPassAccordingToTrackingBar.next(res);
          if (advancestep) {
            this.progressHelper.eventHelper.next({ prev: false, next: true });
          } else {
            this.toaster.success('Template saved successfully!');
          }
        }
      },
      error: (err) => {
        this.toaster.error('Failed to save template.');
      }
    });
  }

  importVendorParts(advancestep: boolean) {
    this.insertUpdateImportDocumnets.templateData.sourceId = 7;
    this.insertUpdateImportDocumnets.isVendor = true;
    const payload = { ...this.insertUpdateImportDocumnets };
    this.commonImportService.importVendorPartTemplate(payload).subscribe({
      next: (res) => {
        if (res.isSuccess) {
          const templateId = res?.response?.templateId ?? res?.response?.moduleData?.templateId ?? '0';
          this.insertUpdateImportDocumnets.importModel.mappingTemplateId = templateId;
          this.importDocumentsService.dataPassAccordingToTrackingBar.next(res);
          if (advancestep) {
            this.progressHelper.eventHelper.next({ prev: false, next: true });
          } else {
            this.toaster.success('Template saved successfully!');
          }
        }
      },
      error: (err) => {
        this.toaster.error('Failed to save template.');
      }
    });
  }

  importConsignment(advancestep: boolean) {
    this.insertUpdateImportDocumnets.templateData.sourceId = 6;
    this.insertUpdateImportDocumnets.isVendor = true;
    const payload = { ...this.insertUpdateImportDocumnets };
    this.commonImportService.importConsignmentTemplate(payload).subscribe({
      next: (res) => {
        if (res.isSuccess) {
          const templateId = res?.response?.templateId ?? res?.response?.moduleData?.templateId ?? '0';
          this.insertUpdateImportDocumnets.importModel.mappingTemplateId = templateId;
          this.importDocumentsService.dataPassAccordingToTrackingBar.next(res);
          if (advancestep) {
            this.progressHelper.eventHelper.next({ prev: false, next: true });
          } else {
            this.toaster.success('Template saved successfully!');
          }
        }
      },
      error: (err) => {
        this.toaster.error('Failed to save template.');
      }
    });
  }
  // private callImportApi(): void {
  //   this.isLoading = true;
    
  //   // Prepare the mapping data for API call
  //   const templateMappingColumns = this.data?.mapData?.rowData?.map((row: any) => ({
  //     systemColumn: row.systemColumn,
  //     mappedColumn: row.mappedColumn,
  //     isRequired: row.isRequired
  //   })) ?? [];

  //   const payload = {
  //     templateData: {
  //       ...this.data.templateData,
  //       templateMappingColumns,
  //       sourceId: this.data?.sourceId ?? 1
  //     },
  //     importCompanyModel: {
  //       mappingTemplateId: this.data?.importData?.mappingTemplateId ?? '0'
  //     }
  //   };

  //   this.importDocumentsService.InsertImportCompanyData(payload).subscribe({
  //     next: (res) => {
  //       this.isLoading = false;
  //       if (res?.isSuccess) {
  //         this.toaster.success('Template saved successfully!');
  //         this.data.importData.mappingTemplateId = res?.response?.moduleData?.templateId ?? '0';
  //       } else {
  //         this.toaster.error('Failed to save template');
  //       }
  //     },
  //     error: (err) => {
  //       this.isLoading = false;
  //       this.toaster.error('Error saving template');
  //       console.error('Template save error:', err);
  //     }
  //   });
  // }
}
